// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2ZHU1","footer":"ModalFilter_footer__PqOEy"};